import { setDefaultOptions } from 'date-fns';
import { ru } from 'date-fns/locale';

setDefaultOptions({ locale: ru });
